import yup from 'yup';
import { hasRegions } from 'cirrus/Dropdown/Region/utils';

const requiredWhenCountryCodeHasRegions = (countryCode, schema) =>
  hasRegions(countryCode) ? schema.strict(true).required(' ') : schema;

// Messages for .required() are empty, because we want the messages to be
// passed by the backend. So we show only show that the form is not valid
// and mark the required fields. The schema is used to show the status indicator
// in the `<FormRow>`s
const schema = yup.object().shape({
  shopId: yup
    .number(' ')
    .required(' ')
    .positive(' ')
    .integer(' '),
  shopName: yup
    .string(' ')
    .strict(true)
    .required(' '),
  shopEmail: yup
    .string(' ')
    .email(' ')
    .required(' '),
  languageCode: yup
    .string(' ')
    .strict(true)
    .required(' '),
  publish: yup
    .mixed(' ')
    .oneOf(['all', 'none'])
    .required(' '),
  countryName: yup
    .string(' ')
    .strict(true)
    .required(' '),
  countryCode: yup
    .string(' ')
    .strict(true)
    .required(' '),
  regionName: yup.string(' ').when('countryCode', requiredWhenCountryCodeHasRegions),
  regionCode: yup.string(' ').when('countryCode', requiredWhenCountryCodeHasRegions),
  address1: yup
    .string(' ')
    .strict(true)
    .required(' '),
  address2: yup.string(' ').strict(true),
  city: yup
    .string(' ')
    .strict(true)
    .required(' '),
  zipcode: yup
    .string(' ')
    .strict(true)
    .required(' '),
  signInEmail: yup
    .string(' ')
    .email(' ')
    .required(' '),
});

export default schema;
